module.exports = __webpack_public_path__ + "img/1F3F3.b245b67a.svg";